var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('grid-container',{staticClass:"appraisal-container"},[_c('Sector',{attrs:{"name":_vm.activeSector.name,"questions":_vm.activeSector.appraisalQuestions}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }